import Panel from './src/panel';

export default Panel;



// WEBPACK FOOTER //
// ./packages/panel/index.js